import { flushSync } from 'react-dom';

interface ViewTransitionResult {
  finished: Promise<void>;
  ready?: Promise<void>;
  updateCallbackDone?: Promise<void>;
}

export function startViewTransition(update: () => void, scopeElement?: Element | null): void {
  const scope = scopeElement || document;
  const startViewTransitionFn = getStartViewTransitionFn(scope);

  if (startViewTransitionFn) {
    try {
      const transition = startViewTransitionFn.call(scope, () => {
        flushSync(() => update());
      });
      // Transitions are aborted when superseded or when DOM state changes
      // mid-capture; an abort rejects all three transition promises.
      transition.finished.catch(() => undefined);
      transition.ready?.catch(() => undefined);
      transition.updateCallbackDone?.catch(() => undefined);
    } catch {
      update();
    }
  } else {
    update();
  }
}

function getStartViewTransitionFn(
  scope: Element | Document,
): ((update: () => void) => ViewTransitionResult) | undefined {
  if ('startViewTransition' in scope && typeof scope.startViewTransition === 'function') {
    const fn = scope.startViewTransition;
    return (update: () => void) => fn.call(scope, update);
  }
}
